import * as React from 'react';
import * as bread from "./style.module.scss";
export const Breadcrumbs = ({ mainPage, subPageName }) => {
  return (
    <nav aria-label="breadcrumb" className={bread.bread}>
      <ul>
        <li>
          <a href="/">Главная</a>
        </li>
        <li>
          <a href="/inostrannye_yazyki/">Иностранные языки</a>
        </li>
        <li>
          {
            mainPage ?
              "Субтитры к сериалам на английском языке"
              :
              <a href={"/inostrannye_yazyki/subtitry_k_serialam_na_angliyskom_yazyke/"}>Субтитры к сериалам на английском языке</a>
          }
        </li>
        {
          !mainPage &&
          <li>
            { subPageName }
          </li>
        }
      </ul>
    </nav>
  );
};
